import { BaseService } from "@/api/baseService";
import httpRequest from "@/api/index";
import type { Page, Port, ShipDto } from "@zhihaoscm/entity";
// import { YES_OR_NO } from "@zhihaoscm/meta";

export class PortServcie extends BaseService<Port, Port, unknown, unknown> {
    /**
     * 区域查询码头
     * @param form
     */
    public async extent(form: ShipDto): Promise<Port[]> {
        const { data } = await this.service.post(
            `${this.path}/extent`,
            {
                ...form
            },
            {
                timeout: 60000
            }
        );
        return data;
    }
    /**
     * 分页查询码头下拉列表
     */
    public async pagingSelector(params: any): Promise<Page<Port>> {
        const { data } = await this.service.get(`${this.path}/paging-selector`, { params });
        return data;
    }

    // 查询码头下拉列表
    public async getCustomPortSelector(params: Record<string, any>): Promise<Port[]> {
        const { data } = await this.service.get(`${this.path}/selector`, { params });
        return data;
    }

    /**
     * @summary 根据港口/码头id查找下级数据
     */
    public async getCustomPortBathLevelId(id: number | undefined | null, params?: Record<string, any>): Promise<any> {
        const { data } = await this.service.get(`${this.path}/bath-level/${id}`, { params });
        return data;
    }
}
export const portServcie = new PortServcie("/port", httpRequest);
